import React from 'react';
import TypedLink from '../TypedLink/TypedLink.js';
import SlideInContent from '../AnimatedElements/SlideInContent.js';
import Accordion from '../AnimatedElements/Accordion.js';
import { ReactSVG } from "react-svg";
import { Link } from "react-router-dom";
import i18n from '../../i18n/i18n.js';
import { withAppContext, ModalsContext } from '../../contexts/AppContext';
import PageHeader from '../PageHeader/PageHeader.js';
import Minicart from '../Minicart/Minicart.js';
import ProductsSlider from '../ProductsSlider/ProductsSlider.js';
import CustomerBarcode from '../CustomerBarcode/CustomerBarcode.js';
import { Utils } from '../../Utils.js';
import SystemPageLinks from '../../components/SystemPageLinks/SystemPageLinks';

import './ProfileMenu.css';

class ProfileMenu extends React.Component {
  static contextType = ModalsContext;

  emptyFormData = {
    coupon_code: '',
  };

  emptyFormErrors = {
    coupon_code: '',
  };

  animationObjectRef = new React.createRef();

  // Csak bejelentkezve elérhető menüpontok. 
  // Tetszőleges tulajdonság megadható a szűréshez.
  signInMenus = [
    { component_name: 'MyMessages' },
    { component_name: 'Profile' },
    { component_name: 'MyOrders' },
    { component_name: 'Wishlist' },
    { component_name: 'RoyaltyCard' },
  ];

  constructor(props) {
    super(props);

    const { appRef } = this.props.appContext;
    this.state = {
      show: false,
      is_signed: appRef.current.get_is_signed(),
      lastVisitedProducts: []
    };
  }

  componentDidUpdate(prevProps, prevState) {
    // Akkor kérjük le az adatokat, amikor a profil menü először válik láthatóvá.
    const { appRef } = this.props.appContext;

    if (!prevState.show && this.state.show && this.state.lastVisitedProducts.length === 0) {
      Utils.get_server_data('/products/'+appRef.current.product_url, { ajax_event: 'get_lastvisited_products' }).then(response => {
        this.setState({ lastVisitedProducts: response.last_visited_products?.products || [] }); 
      });
    }
  }

  is_visible() {
    return this.state.show;
  }

  show() {
    this.setState({ show: true });
    if (this.animationObjectRef.current) {
      this.animationObjectRef.current.setVisible(true);
    }
  }

  hide() {
    const { AppFooterMenuRef } = this.context;

    this.setState({ show: false });
    if (this.animationObjectRef.current) {
      this.animationObjectRef.current.setVisible(false);
    }
    if (AppFooterMenuRef?.current) {
      AppFooterMenuRef.current.set_item_inactive_by_name('menu_profile');
    }
  }

  toggle() {
    if (this.state.show) {
      this.hide();
    }
    else {
      this.show();
    }
  }


  render() {
    const { appRef } = this.props.appContext;
    const { ProfileRef } = this.context;
    const { lastVisitedProducts } = this.state;

    let menus = [];
    if (appRef.current.state.menus && appRef.current.state.menus[7]) {
      menus = appRef.current.state.menus[7];
    }

    if (!appRef.current.state.is_signed) return <></>;

    return <SlideInContent key={this.state.is_signed} ref={this.animationObjectRef}
      className="container floating_container page_profile_menu">
      <PageHeader isHistoryBack="true" no_back="true" no_close="true" custom_icons={[<CustomerBarcode></CustomerBarcode>,<Minicart></Minicart>]} title={i18n.t('profileMenuTitle', { name: appRef.current.state?.user_data?.firstname })}></PageHeader>
      <div className='profile_menu_content'>
        <div className='loyality_card_info'>
          <div className='loyality_card_points'>{i18n.t('loyaltyCardPoints')}: <span>{appRef.current.state?.user_data?.loyalty_points}</span></div>
          <div className='loyality_points_history'>
            <button>
              <ReactSVG src={`/assets/images/history.svg`} /> {i18n.t('profileMenuPointsHistory')}
            </button>
        </div>
        </div>
        <div className='profile-actions'>
          <ul>
            <li>
              <button onClick={() => {this.context.MyMessagesRef.current.show(); }}>
                <ReactSVG src={`/assets/images/notification.svg`} />{i18n.t('profileMenuNotificationsButton')}
                {appRef.current?.state?.unread_messages > 0 && <span className='notification-count'>{appRef.current?.state?.unread_messages}</span>}
              </button>
            </li>
            <li>
              <button onClick={() => {ProfileRef.current.show()}}>
                <ReactSVG src={`/assets/images/profile.svg`} />{i18n.t('profileMenuMyProfileButton')}
              </button>
            </li>
            <li>
              <button onClick={() => {this.context.MyOrdersRef.current.show()}}>
                <ReactSVG src={`/assets/images/cart.svg`} />{i18n.t('profileMenuMyOrdersButton')}
              </button>
            </li>
            <li>
              <button>
                <Link to="/contact" data-type="contact">
                  <ReactSVG src={`/assets/images/support.svg`} />{i18n.t('profileMenuContactSupportButton')}
                </Link>
              </button>
            </li>
          </ul>
        </div>
        {lastVisitedProducts && lastVisitedProducts.length > 0 ?
          <>
            <div className='separator'></div>
            <div className='products_details_products_slider_cont '>
              <ProductsSlider
                boxTitle={i18n.t('productDetailsLastVisitedTitle')}
                products={lastVisitedProducts || []}
                backgroundColor="transparent"
                productBoxType={'default'}
                slideItemCount={1}
                showFavIcon={true}
                showDots={false}
              >
              </ProductsSlider>
            </div>
          </>
          : null}
        <SystemPageLinks className="profile_menu_system_links"></SystemPageLinks>
      </div>

    </SlideInContent>
  }
}

export default withAppContext(ProfileMenu);
